var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('vue-number',_vm._b({ref:"vueNumber",attrs:{"disabled":_vm.disabled,"onkeypress":"return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"},on:{"change":_vm.onChange},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}},'vue-number',_vm.number,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }